import { create } from "zustand";
import { AlertColor } from "@mui/material";

export type SnackbarItem = {
  id: string;
  message: string;
  severity: AlertColor;
};

type SnackbarStore = {
  snackbars: SnackbarItem[];
  addSnackbar: (item: Omit<SnackbarItem, "id">) => void;
  removeSnackbar: (id: string) => void;
};

export const snackbarStore = create<SnackbarStore>((set) => ({
  snackbars: [],
  addSnackbar: (item) => {
    const id = Date.now().toString();
    set((state) => ({
      snackbars: [...state.snackbars, { ...item, id }],
    }));

    setTimeout(() => {
      set((state) => ({
        snackbars: state.snackbars.filter((s) => s.id !== id),
      }));
    }, 3000);
  },
  removeSnackbar: (id) =>
    set((state) => ({
      snackbars: state.snackbars.filter((s) => s.id !== id),
    })),
}));
